const base = '/app'

export const routes = {
  read: `${base}/read`,
  open: `${base}/open`,
  userPosts: `${base}/user_posts`,
  test: `/link-test`,
}
